import { render, staticRenderFns } from "./shiftShop.vue?vue&type=template&id=6f02560c&scoped=true&"
import script from "./shiftShop.vue?vue&type=script&lang=js&"
export * from "./shiftShop.vue?vue&type=script&lang=js&"
import style0 from "./shiftShop.vue?vue&type=style&index=0&id=6f02560c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f02560c",
  null
  
)

export default component.exports